import { render, staticRenderFns } from "./FooterWrapper.vue?vue&type=template&id=42cbe957&scoped=true&"
import script from "./FooterWrapper.vue?vue&type=script&lang=js&"
export * from "./FooterWrapper.vue?vue&type=script&lang=js&"
import style0 from "./FooterWrapper.vue?vue&type=style&index=0&id=42cbe957&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cbe957",
  null
  
)

export default component.exports